import webIcon from "../../assets/images/icons/web.png";
import bulbIcon from "../../assets/images/icons/bulb.png";
import blockchainIcon from "../../assets/images/icons/blockchain.png";
//import gameIcon from "../../assets/images/icons/gameDev.png";

export const SKILLS = [
  { name: "Full-Stack", icon: webIcon },
  { name: "Creative", icon: bulbIcon },
  { name: "Blockchain", icon: blockchainIcon },
  //{ name: 'Game Dev', icon: gameIcon },
];
